import { FlowDetailRoute } from "#routes/organization/flows/[flowId]/detail";
import { RoutePath } from "#utils/route";

export const FlowEditRoute = FlowDetailRoute.concat(
  new RoutePath({
    path: "/edit",
    title: "Edit Flow Connections",
  })
);
